import { createPortal } from "react-dom";
import { ReportDocument } from "../ReportPreview/ReportDocument";
import type { ReportData } from "../ReportComponent/model/types";
import "./print.css";

interface PrintContainerProps {
  reportData: ReportData | null;
  isActive: boolean;
}

/**
 * Monta o relatório no #print-container, o único elemento visível na
 * impressão (ver print.css). É o mesmo documento do preview.
 */
export function PrintContainer({ reportData, isActive }: PrintContainerProps) {
  if (!isActive || !reportData) return null;

  const container = document.getElementById("print-container");
  if (!container) return null;

  return createPortal(
    <div className="print-content">
      <ReportDocument data={reportData} />
    </div>,
    container
  );
}
